var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-db7ff56e"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "w-full items-center justify-between flex h-full" };
var _hoisted_2 = { class: "w-full h-full items-center flex" };
import EIcon from '@common/ui/EIcon.vue';
import { inject, onMounted, onUnmounted } from "vue";
import hotkeys from "hotkeys-js";
import { provideMenuKey } from "@common/ui/EMenu/provideMenuKey";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EMenuItem',
    props: {
        theme: { default: 'light' },
        hotkey: {},
        disabled: { type: Boolean },
        showArrow: { type: Boolean },
        isSelected: { type: Boolean },
        dynamicHeight: { type: Boolean }
    },
    emits: ["select"],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var menuData = inject(provideMenuKey);
        function select() {
            if (props.disabled)
                return;
            emit('select');
        }
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!menuData) {
                    console.error('EMenuItem может вызываться только в EMenu!');
                }
                if (props.hotkey) {
                    hotkeys(props.hotkey, menuData.hotkeyScope, select);
                }
                return [2 /*return*/];
            });
        }); });
        onUnmounted(function () {
            if (props.hotkey) {
                hotkeys.unbind(props.hotkey, menuData.hotkeyScope, select);
            }
        });
        var emit = __emit;
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[
                        "e-menu-item--".concat(_ctx.theme),
                        _ctx.disabled && 'e-menu-item--disabled',
                        _ctx.isSelected && 'e-menu-item--selected',
                        _ctx.dynamicHeight && 'e-menu-item--autoheight'
                    ], "e-menu-item"]),
                onClick: select
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    (_ctx.showArrow)
                        ? (_openBlock(), _createBlock(EIcon, {
                            key: 0,
                            class: "w-1.5 h-2.5 ml-1",
                            icon: "angle-right"
                        }))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
